(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bfs-directory"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-bfs-directory]').forEach(root=>{const input=root.querySelector('[data-category-search-input]');input.addEventListener('input',()=>{const query=input.value.trim().toLocaleLowerCase();let total=0;root.querySelectorAll('[data-category-group]').forEach(group=>{let count=0;group.querySelectorAll('[data-category-item]').forEach(item=>{const match=item.dataset.categorySearch.toLocaleLowerCase().includes(query);item.hidden=!match;if(match){count++;total++;}});group.hidden=count===0;});root.querySelector('[data-category-empty]').hidden=total>0;});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfs-newsletter"]) return;
  try {
    
(()=>{const p=document.getElementById('bfs-popup');if(!p)return;const key='bfs-popup-dismissed';let shown=false;const dismiss=()=>{try{localStorage.setItem(key,String(Date.now()))}catch{}p.close()};p.querySelectorAll('[data-bfs-close]').forEach(b=>b.addEventListener('click',dismiss));p.addEventListener('cancel',dismiss);p.addEventListener('click',e=>{if(e.target===p)dismiss()});const show=()=>{let last=0;try{last=Number(localStorage.getItem(key))}catch{}if(shown||Date.now()-last<7*86400000||document.querySelector('[data-bfs-subscribed]'))return;shown=true;p.showModal()};setTimeout(show,35000);document.addEventListener('mouseout',e=>{if(e.clientY<=0&&matchMedia('(min-width: 900px)').matches)show()});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bfs-pages"] && !Shopify.designMode) return;
  try {
    
function bfsInitPages(){document.querySelectorAll('[data-bfs-pages]').forEach(root=>{const input=root.querySelector('[data-bfs-faq-search]');if(!input||input.dataset.bound)return;input.dataset.bound='true';input.addEventListener('input',()=>{const query=input.value.trim().toLowerCase();let count=0;root.querySelectorAll('.bfs-faq-group').forEach(group=>{let visible=0;group.querySelectorAll('.bfs-question').forEach(question=>{const match=question.textContent.toLowerCase().includes(query);question.hidden=!match;if(match){visible++;count++}});group.hidden=visible===0});root.querySelector('[data-bfs-faq-empty]').hidden=count>0})})}bfsInitPages();document.addEventListener('shopify:section:load',bfsInitPages);

  } catch(e) { console.error(e); }
})();
})();
